import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import Handler from "../../Helpers/Components/Handler";
import { useNavigate, useParams } from "react-router-dom";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder";
import { DropdownButton, DropdownToggle } from "../../Helpers/Components/Dropdown";
import PageChanger from "../../Helpers/Components/Pagination";
import Modal from "../../Helpers/Components/Modal";
import { toast } from "react-toastify";
import * as FileSaver from "file-saver";
import XLSX from 'sheetjs-style';
import Select from 'react-select'

const Customer = () => {
    const { pageNo } = useParams()
    const latestRequest = useRef(0);
    const [chosen, setChosen] = useState("today")
    const [subadminList, setSubadminList] = useState([])
    const [dateRange, setDateRange] = useState({ from: new Date(), to: new Date() })
    const [start, setStart] = useState(new Date())
    const [end, setEnd] = useState(new Date())
    const [details, setDetails] = useState([])
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsgeet.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const [info, setInfo] = useState(false)
    const [downloadSelect, setDownloadSelect] = useState([])
    const [filter, setFilter] = useState({ count: 10, sortBy: "customerId", sort: true, createdBy: "All", custType: "All", type: "All", remarks: "All", custStatus: "All", status: "All" })
    const setPageNo = (value) => navigate(`/download/cust/${value}`)
    const selection = [
        { key: "createdAt", value: "Created At" },
        { key: "createdId", value: "Created By" },
        { key: "refferedBy", value: "Reffered By" },
        { key: "customerId", value: "Customer ID" },
        { key: "type", value: "Type (Online/Offline)" },
        { key: "custType", value: "Cust Type" },
        { key: "remarks", value: "Remarks" },
        { key: "firstName", value: "First Name" },
        { key: "lastName", value: "Last Name" },
        { key: "photo", value: "Photo" },
        { key: "secPhoto", value: "Sec Cust Photo" },
        { key: "dob", value: "DOB" },
        { key: "email", value: "Email" },
        { key: "phone1", value: "Primary Phone" },
        { key: "phone2", value: "Alt Phone" },
        { key: "phone3", value: "Alt Phone 1" },
        { key: "kyc", value: "KYC" },
        { key: "otherKyc", value: "Sec Cust KYC" },
        { key: "tempAddress", value: "Temp Address" },
        { key: "perAddress", value: "Per Address" },
        { key: "status", value: "Status" }
    ]
    const sort = (sortBy, sort) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, sortBy: sortBy, sort: sort }))
    }
    const setFilteration = (name, value) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [name]: value }))
    }
    const getSubadminList = async () => {
        const response = await Handler({ method: "get", url: `/customer/details/get-subadmin`, })
        if (response?.success) {
            setSubadminList(response?.data)
        } else {
            setSubadminList([])
        }
    }
    const exportToExcel = async () => {
        if (!downloadSelect?.length) return toast.error("Choose any field to download")
        setLoading(true)
        const response = await Handler({
            method: 'post', url: `/customer/download`, data: {
                chosen, ...(chosen === "customize" ? { from: dateRange?.from || new Date(), to: dateRange?.to || dateRange?.from || new Date() } : {}),
                ...(filter?.custType !== "All" ? { custType: filter?.custType } : {}),
                ...(filter?.createdBy !== "All" ? { createdId: filter?.createdBy } : {}),
                ...(filter?.type !== "All" ? { type: filter?.type } : {}),
                ...(filter?.custStatus !== "All" ? { custStatus: filter?.custStatus } : {}),
                ...(filter?.status !== "All" ? { status: filter?.status } : {}),
                ...(filter?.remarks !== "All" ? { remarks: filter?.remarks } : {}),
                sort: filter?.sort,
                sortBy: filter?.sortBy,
                selection: downloadSelect?.map(element => element.key)
            }
        });
        if (response?.success) {
            const ws = XLSX?.utils?.json_to_sheet(response?.data?.current);
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, "Customers" + fileExtension);
            setInfo(false)
        } else {
            toast.error(response?.message)
        }
        setLoading(false)
    }
    const getCount = async () => {
        const requestId = ++latestRequest.current;
        setLoading(true)
        const response = await Handler({
            method: 'post', url: `/customer/download`, data: {
                pageNo, count: filter?.count || 10, chosen, ...(chosen === "customize" ? { from: dateRange?.from || new Date(), to: dateRange?.to || dateRange?.from || new Date() } : {}),
                ...(filter?.custType !== "All" ? { custType: filter?.custType } : {}),
                ...(filter?.createdBy !== "All" ? { createdId: filter?.createdBy } : {}),
                ...(filter?.type !== "All" ? { type: filter?.type } : {}),
                ...(filter?.custStatus !== "All" ? { custStatus: filter?.custStatus } : {}),
                ...(filter?.status !== "All" ? { status: filter?.status } : {}),
                ...(filter?.remarks !== "All" ? { remarks: filter?.remarks } : {}),
                sort: filter?.sort,
                sortBy: filter?.sortBy
            }
        });
        if (requestId !== latestRequest.current) return;
        if (response?.success) {
            setDetails(response?.data?.current)
            setNext(response?.data?.next)
        } else {
            setDetails([])
            setNext(false)
        }
        setLoading(false)
    }
    useEffect(() => {
        getCount()
    }, [chosen, dateRange, pageNo, filter])
    useEffect(() => {
        if (chosen === "today") {
            setStart(new Date(new Date()?.setHours(0, 0, 0, 0)))
            setEnd(new Date(new Date()?.setHours(23, 59, 59, 999)))
        }
        if (chosen === "week") {
            const current = new Date();
            const day = current.getUTCDay();
            const weekStart = new Date(current);
            weekStart.setUTCDate(current.getUTCDate() - day);
            const weekEnd = new Date(current);
            weekEnd.setUTCDate(current.getUTCDate() - day + 6);
            setStart(new Date(weekStart.getUTCFullYear(), weekStart.getUTCMonth(), weekStart.getUTCDate(), 0, 0, 0, 0));
            setEnd(new Date(weekEnd.getUTCFullYear(), weekEnd.getUTCMonth(), weekEnd.getUTCDate(), 23, 59, 59, 999));
        }
        if (chosen === "month") {
            const CUTOFF_DAY = 25;
            const CUTOFF_HOUR = 18;
            const current = new Date();
            let startMonth = current.getUTCMonth();
            let startYear = current.getUTCFullYear();
            if (current.getUTCDate() < CUTOFF_DAY || (current.getUTCDate() === CUTOFF_DAY && current.getUTCHours() < CUTOFF_HOUR)) {
                startMonth -= 1;
                if (startMonth < 0) {
                    startMonth = 11;
                    startYear -= 1;
                }
            }
            setStart(new Date(startYear, startMonth, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
            setEnd(new Date(startYear, startMonth + 1, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
        }
        if (chosen === "quarter") {
            const CUTOFF_DAY = 25;
            const CUTOFF_HOUR = 18;
            const current = new Date();
            let startMonth = current.getUTCMonth();
            let startYear = current.getUTCFullYear();
            if (current.getUTCDate() < CUTOFF_DAY || (current.getUTCDate() === CUTOFF_DAY && current.getUTCHours() < CUTOFF_HOUR)) {
                startMonth -= 3;
            }
            while (startMonth < 0) {
                startMonth += 12;
                startYear -= 1;
            }
            setStart(new Date(startYear, startMonth, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
            setEnd(new Date(startYear, startMonth + 3, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
        }
        if (chosen === "year") {
            setStart(new Date(new Date().getUTCFullYear(), 0, 1, 0, 0, 0, 0));
            setEnd(new Date(new Date().getUTCFullYear(), 11, 31, 23, 59, 59, 999));
        }
        if (chosen === "customize" && dateRange?.from) {
            setStart(new Date(new Date(dateRange.from).setHours(0, 0, 0, 0)));
            setEnd(new Date(new Date(dateRange.to || dateRange.from).setHours(23, 59, 59, 999)));
        }
    }, [chosen, dateRange])
    useEffect(() => {
        getSubadminList()
    }, [])
    return (
        <React.Fragment>
            <div className="layout-card">
                <div className="text-end mb-3"><button className="btn border-0 p-0" onClick={() => { setDownloadSelect([]); setInfo(true) }}> <i className="fa-solid fa-download fs-5"></i></button> </div>
                <div className="mb-3 text-center fw-bold fs-5">
                    {moment(start)?.format("DD/MM/YYYY hh:mm A")} - {moment(end)?.format("DD/MM/YYYY hh:mm A")}
                </div>
                <div className="text-center mb-4">
                    <div className="btn-group d-flex flex-column flex-lg-row" role="group" aria-label="Basic mixed styles example">
                        <button type="button" className={`btn dashboard-btns ${chosen === "today" ? "active-dashboard-btns" : ""}`} onClick={() => { setChosen("today") }}>Today</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "week" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("week")}>This Week</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "month" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("month")}>This Month</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "quarter" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("quarter")}>This Quarter</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "year" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("year")}>This Year</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "customize" ? "active-dashboard-btns" : ""}`} onClick={() => { setChosen("customize"); setDateRange({ from: new Date(), to: new Date() }) }}>Customize</button>
                        {/* <button type="button" className={`btn dashboard-btns ${chosen === "total" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("total")}>Total</button> */}
                    </div>
                </div>
                {
                    chosen === "customize"
                        ?
                        <div className="mt-4 justify-content-center row">
                            <div className="d-md-flex align-items-center col-lg-4 col-md-8">
                                <div className="me-2 filter-date datepicker-top">
                                    <DatePicker
                                        autoComplete="off"
                                        selected={dateRange?.from}
                                        id="from"
                                        timeIntervals={15}
                                        showYearDropdown
                                        value={dateRange?.from || ""}
                                        showMonthDropdown
                                        placeholderText="From"
                                        onChange={(date) => setDateRange((prevValues) => ({ ...prevValues, from: date }))}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control form_input text-uppercase me-2"
                                    />
                                </div>
                                <div className="me-2 filter-date datepicker-top">
                                    <DatePicker
                                        autoComplete="off"
                                        selected={dateRange?.to}
                                        showYearDropdown
                                        showMonthDropdown
                                        id="from"
                                        placeholderText="To"
                                        timeIntervals={15}
                                        value={dateRange?.to || ""}
                                        onChange={(date) => setDateRange((prevValues) => ({ ...prevValues, to: date }))}
                                        dateFormat="dd/MM/yyyy"
                                        minDate={dateRange?.from}
                                        disabled={dateRange?.from === "" ? true : false}
                                        className="form-control form_input text-uppercase"
                                    />
                                </div>
                                {dateRange?.from === "" ? "" :
                                    <div className="mb-md-0 mb-2">
                                        <button className="py-0 px-1 d-flex align-items-center btn btn-danger" onClick={() => { setDateRange({ from: new Date(), to: new Date() }); }}>
                                            <i className='fa-xmark fa-solid'></i>
                                        </button></div>}
                            </div>
                        </div>
                        : ""
                }
                <div className="overflow list-table mt-5 mb-4">
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "customerId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("customerId", false)} >▲</i><i className={filter?.sortBy === "customerId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("customerId", true)} >▼</i></div> Cust Id</div></th>
                                <th>Primary No</th>
                                <th> Alt No </th>
                                <th> Alt No 1 </th>
                                <th>Created At</th>
                                <th>
                                    <DropdownToggle label={
                                        <> Created By <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.createdBy === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("createdBy", "All") }} />
                                        {
                                            subadminList?.length ?
                                                subadminList?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.name} className={`${filter?.createdBy === element?.id ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("createdBy", element?.id) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label={
                                        <> Type <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.type === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("type", "All") }} />
                                        <DropdownButton label="Offline" className={`${filter?.type === "Offline" ? "active-option" : ""}`} onClick={() => { setFilteration("type", "Offline") }} />
                                        <DropdownButton label="Online" className={`${filter?.type === "Online" ? "active-option" : ""}`} onClick={() => { setFilteration("type", "Online") }} />
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label={
                                        <> Region <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.custType === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("custType", "All") }} />
                                        <DropdownButton label="Local" className={`${filter?.custType === "local" ? "active-option" : ""}`} onClick={() => { setFilteration("custType", "local") }} />
                                        <DropdownButton label="NRI" className={`${filter?.custType === "nri" ? "active-option" : ""}`} onClick={() => { setFilteration("custType", "nri") }} />
                                        <DropdownButton label="Foreigner" className={`${filter?.custType === "foreigner" ? "active-option" : ""}`} onClick={() => { setFilteration("custType", "foreigner") }} />
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label={
                                        <> Remarks <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.remarks === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "All") }} />
                                        <DropdownButton label="Good" className={`${filter?.remarks === "Good" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "Good") }} />
                                        <DropdownButton label="Bad" className={`${filter?.remarks === "Bad" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "Bad") }} />
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label={
                                        <> Status <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.status === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "All") }} />
                                        <DropdownButton label="Verified" className={`${filter?.status === "Verified" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Verified") }} />
                                        <DropdownButton label="Partially Verified" className={`${filter?.status === "Partially Verified" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Partially Verified") }} />
                                        <DropdownButton label="Unverified" className={`${filter?.status === "Unverified" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Unverified") }} />
                                    </DropdownToggle>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (details && details?.length !== 0 ? details?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${!value['Cust Status'] ? "text-red" : ""}`}>
                                            <td><a className="" href={`/customer/view/${value['Customer Id']}`}>{value['Customer Id']}</a>
                                                <div className="text-capitalize">{((value['First Name'] || "") + " " + (value['Last Name'] || ""))}</div></td>
                                            <td>{value['Primary Number'] || ""}</td>
                                            <td>{value["Alternate Number"] || ""}</td>
                                            <td>{value["Alternate Number 1"] || ""}</td>
                                            <td>{value['Created At'] ? value['Created At']?.split(" ")[0] : ""}</td>
                                            <td className="text-capitalize">{value["Created By"] || "-"}</td>
                                            <td>{value?.Type || "-"}</td>
                                            <td className="text-capitalize">{value["Cust Type"] || "-"}</td>
                                            <td>{value?.Remarks || "-"}</td>
                                            <td className={`${value?.Status === "Verified" ? "text-green" : value?.Status === "Partially Verified" ? "text-yellow" : "text-red"} fw-bold`}><span className=" cursor-pointer"> {value?.Status || "-"}</span></td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={10}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={10} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                   <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilteration("count", Number(selectedoption?.value))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? {label: filter?.count, value: filter?.count} : {label: 10, value: 10}}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='download/cust' />
            </div>
            <Modal size={'lg'} header={"Download"} onShow={info} toggle={() => setInfo(false)} overlayToggle={() => setInfo(false)}>
                <div className="px-4">
                    <div className='d-flex justify-content-between align-items-center'>
                        <p className='text-muted'>Select Field...</p>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id='selectAll' onChange={(e) => { if (e.target?.checked) { setDownloadSelect(selection) } else { setDownloadSelect([]) } }} />
                            <label className="form-check-label" htmlFor='selectAll'> Select All </label>
                        </div>
                    </div>
                    <div className='row'>
                        {
                            selection?.map((element, key) => {
                                return (
                                    <div className="form-check col-lg-4 my-2" key={key}>
                                        <input className="form-check-input" type="checkbox" value={element.value} id={element.key} checked={downloadSelect?.length ? downloadSelect?.find(select => select?.key === element?.key)?.key : false} onChange={(e) => { if (e.target?.checked) { setDownloadSelect((prev) => ([...prev, element])) } else { setDownloadSelect(downloadSelect?.filter(selected => selected.key !== element.key)) } }} />
                                        <label className="form-check-label" htmlFor={element.key}>{element.value}</label>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="modal-footer justify-content-center mt-4">
                    <button disabled={loading} className="btn btn-success" onClick={exportToExcel}>Download</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default Customer;